/** Mobile device detection (IMEXHS `mobileModule`: some controls are hidden on phones and tablets). */

const MOBILE_USER_AGENT = /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i;

interface UserAgentData {
  mobile?: boolean;
}

export function isMobileDevice(): boolean {
  const hint = (navigator as Navigator & { userAgentData?: UserAgentData }).userAgentData?.mobile;
  if (hint === true) return true;
  // iPadOS reports a desktop Safari user agent: a touch-only Mac is an iPad.
  const touchMac = /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
  return touchMac || MOBILE_USER_AGENT.test(navigator.userAgent);
}
